import React, { useState, useEffect } from "react";

function getStringTime(unixTime: number) {
  let formattedTime = "";
  if (unixTime) {
    const elapsed = Math.floor(unixTime / 1000);
    const days = Math.floor(elapsed / (3600 * 24));
    const hours = Math.floor((elapsed % (3600 * 24)) / 3600);
    const minutes = Math.floor((elapsed % 3600) / 60);
    const seconds = elapsed % 60;
    if (days > 0) {
      formattedTime = `${days} days ${hours} hr`;
    } else if (hours > 0) {
      formattedTime = `${hours} hr ${minutes} min`;
    } else if (minutes > 0) {
      formattedTime = `${minutes} min ${seconds} sec`;
    } else {
      formattedTime = `${seconds} sec`;
    }
  } else {
    formattedTime = `0 sec`;
  }
  return formattedTime;
}

export default function TickingTime({ timestamp }: { timestamp: number }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!timestamp || timestamp <= 0) return;
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, [timestamp]);

  if (!timestamp || timestamp <= 0) {
    return <>0 sec</>;
  }

  const elapsed = Date.now() - timestamp;
  return <>{getStringTime(elapsed > 0 ? elapsed : 0)}</>;
}
